<app-main-content-card>
  <button type="button" mat-stroked-button color="primary" (click)="onCancel()">
    {{ "SHARED.BACK" | translate }}
  </button>
  <ng-container *ngrxLet="product$ as product">
    <mat-card class="product-card" *ngIf="product">
      <div class="header">
        <div class="image-container">
          <ng-container *ngIf="product.images!.length > 1">
            <button
              mat-flat-button
              class="prev-btn"
              (click)="prevImage(product.images!.length)"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              mat-flat-button
              class="next-btn"
              (click)="nextImage(product.images!.length)"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </ng-container>
          <div
            class="img"
            [style.background]="
              product.images![activeIndex]
                ? 'url(' +
                  imageBaseUrl +
                  '/' +
                  product.images![activeIndex].largeUrl +
                  ') center no-repeat'
                : ''
            "
          >
            <ng-container *ngIf="!product.images![activeIndex]">
              {{ "SEARCH.RESULT_CARD.NO_IMAGE" | translate }}
            </ng-container>
          </div>
        </div>
        <div class="header-data">
          <h2>{{ product.label }}</h2>
          <p>{{ product.shortDescription }}</p>
          <p>{{ product.detailedDescription }}</p>
        </div>
      </div>
      <div class="prices">
        <div class="d-flex align-items-baseline justify-content-center">
          <div class="price-label me-2">Nettó:</div>
          <span class="price small">{{
            product.minPrice?.netPrice | number: "0.0-0"
          }}</span>
          <span>Ft-tól</span>
          <span class="price small price-divider">-</span>
          <span class="price small">{{
            product.maxPrice?.netPrice | number: "0.0-0"
          }}</span>
          <span>Ft-ig</span>
        </div>
        <div class="d-flex align-items-baseline">
          <div class="price-label me-2">Bruttó:</div>
          <span class="price">{{
            product.minPrice?.grossPrice | number: "0.0-0"
          }}</span>
          <span>Ft-tól</span>
          <span class="price price-divider">-</span>
          <span class="price">{{
            product.maxPrice?.grossPrice | number: "0.0-0"
          }}</span>
          <span>Ft-ig</span>
        </div>
      </div>
      <div class="table-container">
        <table>
          <tbody>
            <!-- TODO adatok, hosszú sorok -->
            <tr>
              <td style="width: 50%">Márka:</td>
              <td style="width: 50%">{{ product.brand }}</td>
            </tr>
            <tr>
              <td>Név:</td>
              <td>{{ product.name }}</td>
            </tr>
            <tr>
              <td>Kiszerelés:</td>
              <td>
                {{ product.amount
                }}{{ "PRODUCTS.UNIT." + product.unit | translate }}
                {{
                  "PACKAGING.PACKAGING." + product.packingMethodSubType
                    | translate
                }}
              </td>
            </tr>
            <tr>
              <td>Tömeg:</td>
              <td>{{ product.grossWeightInKilograms }}kg</td>
            </tr>
            <tr>
              <td>EAN:</td>
              <td>
                <p *ngFor="let ean of product.eanCodes">{{ ean }}</p>
              </td>
            </tr>
            <!-- TODO egyéb proprty-k -->
          </tbody>
        </table>
      </div>
      <ng-container *ngrxLet="logoImages$ as logoImages">
        <div class="merchants" *ngIf="logoImages?.length">
          <p>Easyloton beszállítja:</p>
          <app-image-swiper
            [images]="logoImages!"
            [autoplay]="false"
            [noTopPadding]="true"
          ></app-image-swiper>
        </div>
      </ng-container>
    </mat-card>
  </ng-container>
</app-main-content-card>
